import { Box, Button, Card, CardBody, CardFooter } from "grommet"
import { SidebarGridSection } from "../sections/SidebarGridSection"
import { useGetRouletteThemesQuery, useUpdateRouletteWidgetMutation } from "../../../../api/rouletteWidgetApi"
import { useRouletteStyleContext } from "../context/RouletteStyleContextProvider"
import { rouletteItemBgType, rouletteItemFrameType, roulettePinType } from "../../RouletteConstants"
import { useEffect, useMemo, useRef, useState } from "react"
import SvgBorder from "../../strip/SvgBorder"
import SvgWrapper from "../utils/SvgWrapper"
import "./RouletteThemePreview.css"

const items = [ 
    { id: 1, category: { code: 'common', name: 'Common' }, name: 'Common', component: 'Test 1' },
    { id: 2, category: { code: 'common', name: 'Common' }, name: 'Common', component: 'Test 2' },
    { id: 3, category: { code: 'common', name: 'Common' }, name: 'Common', component: 'Test 3' },
    { id: 4, category: { code: 'other', name: 'Other' }, name: 'Other', component: 'Test 4' },
    { id: 5, category: { code: 'other', name: 'Other' }, name: 'Other', component: 'Test 5' },
    { id: 6, category: { code: 'other', name: 'Other' }, name: 'Other', component: 'Test 6' },
    { id: 7, category: { code: 'other', name: 'Other' }, name: 'Other', component: 'Test 7' },
    { id: 8, category: { code: 'other', name: 'Other' }, name: 'Other', component: 'Test 8' },
    { id: 9, category: { code: 'other', name: 'Other' }, name: 'Other', component: 'Test 9' },
    { id: 10, category: { code: 'other', name: 'Other' }, name: 'Other', component: 'Test 10' },
    { id: 11, category: { code: 'other', name: 'Other' }, name: 'Other', component: 'Test 11' },
]

export const RouletteThemesTab = () => {

    const { data: themesData, isSuccess: areThemesLoaded } = useGetRouletteThemesQuery();
    const [updateRouletteWidget, { isLoading: isUpdatingRoulette, isSuccess: isRouletteUpdated }] = useUpdateRouletteWidgetMutation();

    const [themes, setThemes] = useState([]);
    const [selectedTheme, setSelectedTheme] = useState();

    const { setRouletteStyle } = useRouletteStyleContext();

    useEffect(() => {
        if (areThemesLoaded) {
            const themesWithPreview = themesData.map(theme => ({ ...theme, ...{ component: <RouletteThemePreview themeStyles={theme} /> } }))
            setThemes(themesWithPreview);

            // const themesWithPreview = themesData.map(theme => ({ ...theme, ...{ component: <RouletteThemePreview themeStyles={theme} /> } }))
            // const theme1 = {...themesWithPreview[0], ...{ category: { code: 'other', name: 'Other' }}}
            // const theme2 = {...themesWithPreview[0], ...{ category: { code: 'lol', name: 'League of Legends' } }}
            // const theme3 = {...themesWithPreview[0], ...{ category: { code: 'gta', name: 'Grand Theft Auto V' }}}
        
            // setThemes(new Array(5).fill().map(() => themesWithPreview[0]).concat(new Array(5).fill().map(() => theme1)).concat(new Array(5).fill().map(() => theme2)).concat(new Array(5).fill().map(() => theme3)));
        }
    }, [areThemesLoaded])

    const handleThemeSelection = (theme) => {
        console.log(theme);
        

        setRouletteStyle(theme);
        setSelectedTheme(theme);
    }

    const handleSave = () => {
        const newTheme = { ...selectedTheme };
        delete newTheme.category;
        delete newTheme.component;
        delete newTheme.name;

        console.log(newTheme);
        
        updateRouletteWidget(newTheme);
    }

    return (
        <Card>
            <CardBody gap="small">
                <SidebarGridSection items={themes} onClick={handleThemeSelection} />
            </CardBody>
            <CardFooter justify="end" pad={{ top: 'none', left: 'medium', right: 'medium', bottom: 'medium' }}>
                <Button label="Save" primary type="submit" onClick={handleSave} busy={isUpdatingRoulette} success={isRouletteUpdated} />
                {/* <Button label="Delete" /> */}
            </CardFooter>
        </Card>
    )
}

const getBackgroundStyle = (backgroundStyle) => {

    let values = {
        borderRadius: `${backgroundStyle.radius}px`,
    };

    if (backgroundStyle.color) {
        const color = backgroundStyle.color;
        values = { ...values, ...{
            backgroundImage: `linear-gradient(${color.angle}deg, ${color.color1} 0%, ${color.color2} 100%)`
        }};
    }

    if (backgroundStyle.image) {
        const image = backgroundStyle.image;

        values = { ...values, ...{
            backgroundImage: `url("${image.url}")`,
            filter: `hue-rotate(${image.hueRotate}deg) saturate(${image.saturate}%)`,
        }};
    }

    if (backgroundStyle.shadow) {
        const shadow = backgroundStyle.shadow;
        values = { ...values, ...{
            filter: `drop-shadow(${shadow.color} ${shadow.horizontalOffset}px ${shadow.verticalOffset}px ${shadow.blur}px)`,
        }}
    }

    if (backgroundStyle.shadow && backgroundStyle.image) {
        const shadow = backgroundStyle.shadow;
        const image = backgroundStyle.image;
        values = { ...values, ...{
            filter: `drop-shadow(${shadow.color} ${shadow.horizontalOffset}px ${shadow.verticalOffset}px ${shadow.blur}px) hue-rotate(${image.hueRotate}deg) saturate(${image.saturate}%)`,
        }}
    }

    return values;
}

const getBorderStyle = (borderStyle) => {

    let values = {}

    if (borderStyle.color) {
        const color = borderStyle.color;
        values = { ...values, ...{
            borderWidth: color.width,
            radius: color.radius,
            color1: color.color1,
            color2: color.color2,
            gradientAngle: color.gradientAngle,
        }}
    }

    if (borderStyle.image) {
        const image = borderStyle.image;
        values = { ...values, ...{
            image: image.url,
            filter: `hue-rotate(${image.hueRotate}deg) saturate(${image.saturate}%)`,
        }}
    }

    if (borderStyle.shadow) {
        const shadow = borderStyle.shadow;
        values = { ...values, ...{
            filter: `drop-shadow(${shadow.color} ${shadow.verticalOffset}px ${shadow.horizontalOffset}px ${shadow.blur}px)`
        }}
    }

    if (borderStyle.shadow && borderStyle.image) {
        const shadow = borderStyle.shadow;
        const image = borderStyle.image;
        values = { ...values, ...{
            image: image.url,
            filter: `drop-shadow(${shadow.color} ${shadow.horizontalOffset}px ${shadow.verticalOffset}px ${shadow.blur}px) hue-rotate(${image.hueRotate}deg) saturate(${image.saturate}%)`,
        }}
    }

    return values;
}

const getPinStyle = (pinStyle) => {

    let values = {};

    if (pinStyle.vector) {
        const vector = pinStyle.vector;
        
        values = { ...values, ...{
            url: vector.url,
            stroke: vector.stroke, 
            strokeWidth: `${vector.strokeWidth}px`,
            color1: vector.color1,
            color2: vector.color2,
            gradientAngle: vector.gradientAngle
        }}
    }

    if (pinStyle.image) {
        const image = pinStyle.image;
        values = { ...values, ...{
            url: image.url,
            filter: `hue-rotate(${image.hueRotate}deg) saturate(${image.saturate}%)`,
        }};
    }

    if (pinStyle.shadow) {
        const shadow = pinStyle.shadow;
        values = { ...values, ...{
            filter: `drop-shadow(${shadow.color} ${shadow.horizontalOffset}px ${shadow.verticalOffset}px ${shadow.blur}px)`,
        }}
    }

    if (pinStyle.shadow && pinStyle.image) {
        const shadow = pinStyle.shadow;
        const image = pinStyle.image;
        values = { ...values, ...{
            filter: `drop-shadow(${shadow.color} ${shadow.horizontalOffset}px ${shadow.verticalOffset}px ${shadow.blur}px) hue-rotate(${image.hueRotate}deg) saturate(${image.saturate}%)`,
        }}
    }

    return values;
}

const RouletteThemePreview = ({ themeStyles }) => {

    const [loaded, setLoaded] = useState(false);
    const [background, setBackground] = useState();
    const [border, setBorder] = useState();
    const [pin, setPin] = useState();
    const rouletteContainerRef = useRef();
    const [scale, setScale] = useState(0.3);

    const rouletteBackground = useMemo(() => {
    
        const data = themeStyles;

        if (!data) return {};
        
        if (data.backgroundType === rouletteItemBgType.COLOR) {
    
            return {
                radius: data.backgroundRadius,
                color: {
                    color1: data.backgroundColor1,
                    color2: data.backgroundColor2,
                    angle: data.backgroundColorAngle
                },
                shadow: {
                    color: data.backgroundShadowColor,
                    horizontalOffset: data.backgroundShadowHorizontalOffset,
                    verticalOffset: data.backgroundShadowVerticalOffset,
                    blur: data.backgroundShadowBlur
                }
            }
        }

        if (data.backgroundType === rouletteItemBgType.IMAGE) {
            
            return {
                radius: data.backgroundRadius,
                image: {
                    url: data.backgroundImage?.url,
                    hueRotate: data.backgroundImageHueRotate,
                    saturate: data.backgroundImageSaturate
                },
                shadow: {
                    color: data.backgroundShadowColor,
                    horizontalOffset: data.backgroundShadowHorizontalOffset,
                    verticalOffset: data.backgroundShadowVerticalOffset,
                    blur: data.backgroundShadowBlur
                }
            }
        }

        return {};
    }, [themeStyles])

    const rouletteBorder = useMemo(() => {

        const data = themeStyles;

        if (!data) return {};

        if (data.frameType === rouletteItemFrameType.OUTLINE) {

            return {
                color: {
                    width: data.frameOutlineWidth,
                    radius: data.frameRadius,
                    color1: data.frameColor1,
                    color2: data.frameColor2,
                    gradientAngle: data.frameColorGradientAngle,
                },
                shadow: {
                    color: data.frameShadowColor,
                    horizontalOffset: data.frameShadowHorizontalOffset,
                    verticalOffset: data.frameShadowVerticalOffset,
                    blur: data.frameShadowBlur
                }
            }
        }

        if (data.frameType === rouletteItemFrameType.IMAGE) {
            
            return {
                image: {
                    url: data.frameImage?.url,
                    hueRotate: data.frameImageHueRotate,
                    saturate: data.frameImageSaturate
                },
                shadow: {
                    color: data.frameShadowColor,
                    horizontalOffset: data.frameShadowHorizontalOffset,
                    verticalOffset: data.frameShadowVerticalOffset,
                    blur: data.frameShadowBlur
                }
            }
        }

        return {};
    }, [themeStyles])

    const roulettePin = useMemo(() => {

        const data = themeStyles;

        if (!data) return {};

        if (data.pinType === roulettePinType.VECTOR) {
            return {
                vector: {
                    url: data.pinImage?.url,
                    stroke: data.pinOutlineColor,
                    strokeWidth: data.pinOutlineWidth,
                    color1: data.pinColor1,
                    color2: data.pinColor2,
                    gradientAngle: data.pinColorGradientAngle
                },
                shadow: {
                    color: data.pinShadowColor,
                    horizontalOffset: data.pinShadowHorizontalOffset,
                    verticalOffset: data.pinShadowVerticalOffset,
                    blur: data.pinShadowBlur
                }
            }
        }

        if (data.pinType === roulettePinType.IMAGE) {
            return {
                image: {
                    url: data.pinImage?.url,
                    hueRotate: data.pinImageHue,
                    saturate: data.pinImageSaturation
                },
                shadow: {
                    color: data.pinShadowColor,
                    horizontalOffset: data.pinShadowHorizontalOffset,
                    verticalOffset: data.pinShadowVerticalOffset,
                    blur: data.pinShadowBlur
                }
            }
        }

        return {};
    }, [themeStyles])

    useEffect(() => {
        setBackground(getBackgroundStyle(rouletteBackground));
    }, [rouletteBackground])

    useEffect(() => {
        setBorder(getBorderStyle(rouletteBorder));
    }, [rouletteBorder])

    useEffect(() => {
        setPin(getPinStyle(roulettePin));
    }, [roulettePin])

    useEffect(() => {
        const observer = new ResizeObserver(() => {
            if (!rouletteContainerRef.current) {
                return;
            }
            const rect = rouletteContainerRef.current.getBoundingClientRect();

            const baseWidth = 1000;
            const newScale = Math.min(rect.width / baseWidth, 0.3);
            setScale(newScale);
        });

        if (rouletteContainerRef.current) {
            observer.observe(rouletteContainerRef.current);
        }

        return () => observer.disconnect();
    }, [])

    return (
        <Box pad={'medium'} justify="center" style={{
            opacity: themeStyles.frameType === rouletteItemFrameType.IMAGE && loaded ? 1 : (themeStyles.frameType === rouletteItemFrameType.IMAGE ? 0 : 1),         
            transition: "opacity 0.1s ease",
        }}>
            <div ref={rouletteContainerRef} className="roulette-preview-container">
                <div
                    className="roulette-preview-scale-wrapper"
                    style={{
                        transform: `scale(${scale})`,
                        transformOrigin: "center center"
                    }}
                >
                    {themeStyles.frameType === rouletteItemFrameType.OUTLINE && border && Object.keys(themeStyles).length > 0 && <SvgBorder 
                        id={`roulette-preview-border-${themeStyles.id}`}
                        width={'1010'} 
                        height={'210'} 
                        borderWidth={border.borderWidth} 
                        radius={border.radius} 
                        gradient={[
                            { offset: "0%", color: border.color1 },
                            { offset: "100%", color: border.color2 }
                        ]}
                        gradientAngle={border.gradientAngle}
                        style={{ position: 'absolute', zIndex: 1, filter: border.filter }}
                    />}
                    {themeStyles.frameType === rouletteItemFrameType.IMAGE && border && <div className="roulette-frame" style={border}>
                        <img src={border.image} onLoad={() => setLoaded(true)}></img>
                    </div>}
                    <div className="roulette-preview-background" style={background}></div>
                    <div className="roulette-preview-arrow">
                        <div className="roulette-preview-arrow-pic">
                            {/* { pinStyle.vector && PinComponent && <PinComponent id="_555" style={{ ...pin, position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', height: '50px', width: '50px' }} gradient={[ { offset: "0%", color: pin.color1 }, { offset: "100%", color: pin.color2 } ]} gradientAngle={pin.gradientAngle} /> } */}
                            { pin && roulettePin.vector && pin.url && <SvgWrapper id={`_555_${themeStyles.id}`} className="roulette-preview-arrow-vector" src={pin.url} style={pin} gradient={[ { offset: "0%", color: pin.color1 }, { offset: "100%", color: pin.color2 } ]} gradientAngle={pin.gradientAngle} />}
                            { pin && roulettePin.image && <img src={pin.url} style={{ ...pin, position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} /> }
                        </div>
                    </div>
                </div>
            </div>
        </Box>
    )
}